/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Initiative } from '../../models/initiative';

export interface UpdateInitiative$Params {
  id: string;
      body?: Initiative
}

export function updateInitiative(http: HttpClient, rootUrl: string, params: UpdateInitiative$Params, context?: HttpContext): Observable<StrictHttpResponse<Initiative>> {
  const rb = new RequestBuilder(rootUrl, updateInitiative.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Initiative>;
    })
  );
}

updateInitiative.PATH = '/initiative/{id}';
